module.exports = __webpack_public_path__ + "img/Enmascarar grupo 10.a956b406.svg";